import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'
import { secondsToMilliseconds } from 'date-fns'

export const useTimeStore = defineStore('time', () => {
  const currentTime: Ref<Date> = ref(new Date())
  const currentTimeUpdateInterval: Ref<ReturnType<typeof setInterval> | undefined> = ref()

  const updateCurrentTime = () => {
    currentTime.value = new Date()
  }

  const startCurrentTimeUpdate = () => {
    stopCurrentTimeUpdate()
    currentTimeUpdateInterval.value = setInterval(
      updateCurrentTime,
      secondsToMilliseconds(import.meta.env.VITE_REFRESH_INTERVAL_TIME || 1)
    )
  }

  const stopCurrentTimeUpdate = () => {
    if (currentTimeUpdateInterval.value) {
      clearInterval(currentTimeUpdateInterval.value)
      currentTimeUpdateInterval.value = undefined
    }
  }

  return { currentTime, startCurrentTimeUpdate, stopCurrentTimeUpdate }
})
